import { Close, Search } from '@mui/icons-material';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { useCampus } from '../../hooks/useCampus';

interface Props {
  onSearch: (search: string) => void;
}

export const CampusSearch: FC<Props> = ({ onSearch }) => {
  const { search, changeSearch } = useCampus();

  const handleSearchDirectorChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    changeSearch(value);
    onSearch(value);
  };

  const filterCleaning = () => {
    if (search === '') {
      return;
    }
    changeSearch('');
    onSearch('');
  };

  return (
    <Grid item xs={12} md={6}>
      <TextField
        label="Buscar"
        variant="outlined"
        fullWidth
        size={'small'}
        value={search}
        onChange={handleSearchDirectorChange}
        sx={{ py: 1 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Close onClick={filterCleaning} sx={{ cursor: 'pointer' }} />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};
